import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import againIcon from '@lifesize/ux-assets/vectors/svgIcons/again.svg';
import micIcon from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import micOffIcon from '@lifesize/ux-assets/vectors/svgIcons/mic-off.svg';
import EndCallButton from 'components/InCall/InCallFooterButtons/EndCallButton';
import CallDuration from 'components/InCall/CallDuration';
import Tooltip from 'components/Tooltip/Tooltip';
import classes from './MiniPlayerFooter.module.scss';
import callFooterClasses from '../InCall/CallFooter.module.scss';

const getMuteClass = (props) => {
  if (props.isAudioEnabled) {
    return '';
  }
  if (props.isMutedByServer) {
    return classes.mutedByServer;
  }
  return classes.muted;
};

const getMuteTooltipMessage = (props) => {
  const { isAudioEnabled, isMutedByServer,  isModerator } = props;
  if (isAudioEnabled) {
    return <FormattedMessage id="components.incall.controls.audioMute.tooltip.off" />;
  }
  if (isMutedByServer && !isModerator) {
    return <FormattedMessage id="notification.muteAll" />;
  }
  return <FormattedMessage id="components.incall.controls.audioMute.tooltip.on" />;
};

const MiniPlayerFooter = (props) => {
  const muteIcon = props.isAudioEnabled
    ? <SVG src={micIcon} data-testid="micIcon" />
    : <SVG src={micOffIcon} data-testid="micOffIcon" />;
  const muteClass = [callFooterClasses.inCallButton, getMuteClass(props)].join(' ');
  const muteButtonTooltip = getMuteTooltipMessage(props);
  return (
    <div className={classes.container}>
      <button id="switchViewButton" className={callFooterClasses.inCallButton} onClick={props.onSwitchViewClick}>
        <SVG src={againIcon} data-testid="againIcon" />
        <Tooltip
          location="top"
          fixPosition
          className={classes.switchTooltip}
          label={(<FormattedMessage id="components.miniplayer.switchView" />)}
        />
      </button>
      <button id="toggleAudioButton" className={muteClass}
        disabled={props.isMutedByServer && !props.isModerator}
        onClick={props.onToggleAudioClick}
      >
        {muteIcon}
        <Tooltip
          className={classes.muteTooltip}
          fixPosition
          location="top"
          label={muteButtonTooltip}
        />
      </button>
      <EndCallButton onClick={props.onEndCallClick} />
      <div className={classes.callDuration}>
        {props.startTime && <CallDuration startTime={props.startTime} />}
      </div>
    </div>
  );
};

getMuteTooltipMessage.propTypes = {
  isAudioEnabled: PT.bool,
  isModerator: PT.bool,
  isMutedByServer: PT.bool
};

MiniPlayerFooter.propTypes = {
  intl: PT.object,
  isAudioEnabled: PT.bool,
  isModerator: PT.bool,
  isMutedByServer: PT.bool,
  onEndCallClick: PT.func,
  onSwitchViewClick: PT.func,
  onToggleAudioClick: PT.func,
  startTime: PT.number
};

export default MiniPlayerFooter;
